import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost';
type Size = 'md' | 'sm';

const styles: Record<Variant, string> = {
  primary:
    'bg-accent text-ink font-bold hover:bg-yellow-400 disabled:bg-white/20 disabled:text-white/50',
  secondary: 'bg-white/10 text-white font-semibold hover:bg-white/15 disabled:text-white/40',
  ghost: 'bg-transparent text-white/80 hover:bg-white/10',
};

// Sizes are a prop rather than className overrides: Tailwind orders utilities by value, so a
// `min-h-10` passed in className loses to the base `min-h-12` regardless of class order.
const sizes: Record<Size, string> = {
  md: 'min-h-12 px-5 text-base',
  sm: 'min-h-10 px-4 text-sm',
};

export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; size?: Size }) {
  return (
    <button
      type="button"
      className={`inline-flex min-w-11 items-center justify-center rounded-xl transition-colors disabled:cursor-not-allowed ${sizes[size]} ${styles[variant]} ${className}`}
      {...rest}
    />
  );
}
